import { COMPANY_CONTACT } from "../../../settings/constants"
import { RadioInput } from '../../sharable_components/small_components/input_boxes/input_boxes'

import { useDispatch } from 'react-redux'

import { useState } from 'react'


import './contact.css'

import { Button, Paper, TextField } from "@mui/material"
import { post_short_alert_message } from "../../../actions/error_actions"
import { send_email_emailJs } from '../../../actions/shared_actions'
import { Spinner } from "../../sharable_components/small_components/alerts/loading"
import { FadeInSection } from "../../application_components/public_landing_page/home_window"

export const ContactForm = () => {
    const dispatch = useDispatch()
    const [load, set_load] = useState(false)

    const [form_errors, setForm_errors] = useState(null)
    const orig_email = {
        sys_user:"",
        sys_user_email:"",
        message:"",
        message_category:"Inquiry",
        // sys_user_phone:""
    }

    const [emailBody, setEmailBody] = useState(orig_email)

    const sendEmail = (e)=>{
        set_load(true)
        setForm_errors(null)
        e.preventDefault();
        if (validate_form(emailBody).length !==0) {
            setForm_errors(validate_form(emailBody))
            set_load(false)
        }
        else{
            send_email_emailJs(emailBody)
                .then((res)=>{
                    dispatch(post_short_alert_message({success:"Success"}))
                    setEmailBody(orig_email)
                })
                .catch((e)=>dispatch(post_short_alert_message({error:"Sorry, System Error. Try again Later"})))
                .finally(()=>set_load(false))
        }
    }

    return (
        <div className="contact_body" >
            <div>
                <FadeInSection>
                    <h4 className='pad_left'>
                        Contacts
                    </h4>
                </FadeInSection>
                <FadeInSection>
                    <Paper className="contact_form contacts paper">
                        <div className='table_all_contact'>
                            <div className="table_header_contact">
                                Call, Text, Whatsapp
                            </div>
                            <div className="table_content_contact">
                                <div>
                                    {COMPANY_CONTACT.phones[0]}
                                </div>
                                <div>
                                    {COMPANY_CONTACT.phones[1]}
                                </div>
                            </div>
                        </div>
                        <div className='table_all_contact'>
                            <div className="table_header_contact">
                                Email
                            </div>
                            <div className="table_content_contact">
                                {COMPANY_CONTACT.emails[0]}
                            </div>
                        </div>
                    
                    </Paper>
                </FadeInSection>
            </div>
            <FadeInSection>
                <form onSubmit={e=>sendEmail(e)} onReset={e=>setEmailBody(orig_email)} >
                    <h4>
                        Query form
                    </h4>
                    <FadeInSection>
                        <Paper className="contact_form query_form paper">
                            <div className="margined">
                                <TextField label="Full Names"  required fullWidth type={"text"} value={emailBody.sys_user} onChange={e=>setEmailBody({...emailBody, sys_user:e.target.value})} placeholder="eg John Doe"/>
                            </div>
                            <div className="margined">
                                <TextField label="Email Address"  required fullWidth type={"email"} value={emailBody.sys_user_email} onChange={e=>setEmailBody({...emailBody, sys_user_email:e.target.value})} placeholder="eg john.doe@example.com"/>
                            </div>
                            <div className="margined">
                                <TextField label="Phone Number"  required fullWidth type={"tel"} value={emailBody.sys_user_phone} onChange={e=>setEmailBody({...emailBody, sys_user_phone:e.target.value})} placeholder="eg 0700000000"/>
                            </div>
                            <p>
                                <i>Help us categorize your query</i>
                            </p>
                            <div className='flex_to_row_buttons'>
                                <RadioInput 
                                    name='query_type' 
                                    type='radio' 
                                    value='query' 
                                    label='I have an Inquiry' 
                                    setValue={e=>setEmailBody({...emailBody, message_category:"Inquiry"})}
                                    />
                                <RadioInput 
                                    name='query_type' 
                                    type='radio' 
                                    value='complaint' 
                                    label='I have a Complaint'
                                    setValue={e=>setEmailBody({...emailBody, message_category:"Complaint"})}
                                    />
                                <RadioInput 
                                    name='query_type' 
                                    type='radio' 
                                    value='Compliment' 
                                    label='I have a General Comment/Compliment'
                                    setValue={e=>setEmailBody({...emailBody, message_category:"Compliment/Comment"})} 
                                    />
                            </div>
                            <div className="margined">
                                <TextField
                                    label="Message"
                                    required
                                    multiline
                                    rows={4}
                                    placeholder={'Type...'} 
                                    value={emailBody.message} 
                                    fullWidth
                                    onChange={e=>setEmailBody({...emailBody, message:e.target.value})} />
                            </div>
                            <div  className='align_right'>
                                <small><i>{emailBody.message.replace(" ","").length} chars</i></small>
                            </div>
                            {form_errors && form_errors.map(e => 
                            <div key={form_errors.indexOf(e)} className='form_errors'>
                                <small><li>{e}</li></small>
                                </div>
                            )
                            }
                            <div className='align_right'>
                                <div className="margined">
                                    <Button type="submit"  fullWidth variant="contained" size="large" color="warning">{load? <Spinner />: "Submit"}</Button>
                                </div>
                                <div className="margined">
                                    <Button fullWidth variant="outlined" size="large" color="info" type="reset" >Reset</Button>
                                </div>
                            </div>
                        </Paper>
                    </FadeInSection>
                </form>
            </FadeInSection>
        </div>
    )
}


const validate_form = (formData) => {
    const form_errors = []
    if (formData?.sys_user.split(" ").length <2 ) form_errors.push("Full names must be more than one name")
    if (!formData?.sys_user_email?.split("@")[1]?.includes(".")) form_errors.push("Enter a valid email address")
    if (formData?.message.replace(" ","").length < 20) form_errors.push("Message must be more than 20 characters")
    if (formData?.sys_user_phone){
        if (formData?.sys_user_phone.length < 10 || isNaN(Number(formData?.sys_user_phone))) form_errors.push("Enter a valid phone number")
    }

    return form_errors
    
}
